import { SUPPORTED_COUNTRIES } from '@/lib/supportedCountries'
import { coverageFacts } from '@/content/facts'

const FIAT_CURRENCIES = coverageFacts.fiatCurrencies
const STABLECOIN_ASSETS = coverageFacts.stablecoins.map((coin) => coin.symbol) as typeof coverageFacts.stablecoins[number]['symbol'][]
type PartnerLogo = { src: string; alt: string }

const fiatCountries = SUPPORTED_COUNTRIES.filter((country) =>
  country.currencies.some((currency) => FIAT_CURRENCIES.includes(currency as (typeof FIAT_CURRENCIES)[number]))
)

const supportedPairs = coverageFacts.supportedPairs.map((pair) => `${pair.base}↔${pair.quote}` as const)

const payoutRails = coverageFacts.fiatRails

export const PROVIDER_COVERAGE = {
  countriesCount: fiatCountries.length,
  currenciesCount: FIAT_CURRENCIES.length,
  assetsSupported: STABLECOIN_ASSETS,
  supportedPairs,
  payoutRails,
  partnerLogos: [] as PartnerLogo[],
} as const
